<template>
	<div class="machine-group">
		<div class="el-search vue-top-padding radius">
			<div class="el-left">
				<el-button
					@click="handlerInsert"
					v-hasPerm="['product:library:insert']"
					type="primary"
					size="small"
					icon="el-icon-plus"
					style="margin: 0"
					>{{ $t("product.ProductLibrary.994606-0") }}</el-button
				>
			</div>
			<div class="el-right">
				<el-form
					:model="search"
					:inline="true"
					label-width="10px"
					size="small"
					class="demo-form-inline el-input-height">
					<el-form-item prop="name" style="margin-bottom: 0">
						<el-input
							v-model="search.name"
							:placeholder="$t('product.ProductLibrary.994606-1')"></el-input>
					</el-form-item>
					<el-form-item style="margin: 0">
						<el-button type="primary" @click="onSubmit" icon="el-icon-search">{{
							$t("common.search")
						}}</el-button>
						<el-button @click="resetSearch()" icon="el-icon-refresh">{{
							$t("common.reset")
						}}</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
		<div class="vue-padding">
			<el-table
				v-loading="loading"
				:empty-text="$t('common.noData')"
				:element-loading-text="$t('common.loading')"
				:data="tableList"
				style="width: 100%"
				max-height="638"
				:border="true">
				<el-table-column
					prop="name"
					:show-overflow-tooltip="true"
					:label="$t('product.ProductLibrary.994606-1')"
					:align="'center'"></el-table-column>
				<el-table-column
					prop="image"
					:label="$t('product.ProductLibrary.994606-2')"
					:align="'center'">
					<template slot-scope="scope">
						<el-image
							@click="handlerLookItem(scope.row)"
							:preview-src-list="srcList"
							:src="scope.row.url"
							fit="contain"
							style="width: 50px; height: 50px; cursor: pointer"></el-image>
					</template>
				</el-table-column>
			<el-table-column
				label="Audit Status"
				width="100"
				:align="'center'">
				<template slot-scope="scope">
					<span>{{ handlerROpenDoorStatus(scope.row) }}</span>
				</template>
			</el-table-column>
			<el-table-column
				prop="openDoorSkuDTO.rejectReasion"
				label="Reject Reason"
				width="220"
				:show-overflow-tooltip="true"
				:align="'center'">
				<template slot-scope="scope">
					<span>{{ handlerRejectReason(scope.row) }}</span>
				</template>
			</el-table-column>
			<el-table-column
				:label="$t('product.ProductLibrary.994606-3')"
				:align="'center'"
				fixed="right"
				:width="360"
			>
					<template slot-scope="scope">
						<el-button
							size="mini"
							v-if="handlerIsStatus(scope.row, null)"
							@click="handlerUploadImg(scope.row)"
							>{{ $t("product.uploadImgs") }}</el-button
						>
						<el-button
							size="mini"
							v-if="handlerIsStatus(scope.row, 3)"
							@click="handlerReUploadImg(scope.row)"
							>{{ $t("product.reUploadImgs") }}</el-button
						>
						<el-button
							size="mini"
							v-if="!handlerIsStatus(scope.row, null)"
							@click="handlerLookImgs(scope.row)"
							>{{ $t("product.lookImgs") }}</el-button
						>
						<el-button
							style="margin: 3px"
							size="mini"
							type="success"
							@click="getProductType(scope.row)"
							>{{ $t("product.ProductLibrary.994606-4") }}</el-button
						>
						<el-button
							v-if="String(scope.row.uId) === String(uId) || Number(pId) === 0"
							style="margin: 3px"
							size="mini"
							v-hasPerm="['product:library:delete']"
							type="danger"
							@click="delProductType(scope.row)"
							>{{ $t("product.ProductLibrary.994606-5") }}</el-button
						>
					</template>
				</el-table-column>
			</el-table>
			<el-pagination
				v-if="tableList.length > 0"
				background
				layout="prev, pager, next"
				:current-page="page.pageIndex"
				:total="page.totalSize"
				:page-size="page.pageSize"
				@current-change="currentChange"></el-pagination>
		</div>
			<add-product
				:dialogProduct="dialogProduct"
				v-on:cancel="cancel"
				:productTags="productTags"
				:product="product"
				:fromMaterial="fromMaterial">
			</add-product>
		<UploadImgs
			@close="closeUploadImg"
			@refresh="refreshUploadImg"
			:show="showUploadImg"
			:isReUpload="isReUpload"
			:product="productItem"
		/>
		<LookImgs @close="closeLookImg" :show="showLookImg" :product="productItem" />
	</div>
</template>

<script>
import addProduct from "_c/product/AddProduct";
import UploadImgs from "_c/product/UploadImgs.vue";
import LookImgs from "_c/product/LookImgs.vue";

const createEmptyProduct = () => ({
	costPrice: "",
	goodsTags: [],
	name: "",
	typeId: "",
	url: "",
	content: "",
	introduction: "",
	no: "",
	goodsBarcode: "",
	notes: "",
	id: "",
});

export default {
	name: "ProductLibrary",
	components: {
		addProduct,
		UploadImgs,
		LookImgs,
	},
	data() {
		return {
			search: {},
			loading: false,
			tableList: [],
			page: {
				pageSize: 10,
				pageIndex: 1,
			},
			dialogProduct: false,
			product: createEmptyProduct(),
			// 弹窗相关
			productTags: [],
			srcList: [],
			showUploadImg: false,
			showLookImg: false,
			productItem: {},
			isReUpload: false,
			openDoorResList: [],
			pId: -1,
			uId: -1,
			fromMaterial: "0",
		};
	},

	async mounted() {
		this.pId = localStorage.getItem("pId") || -1;
		this.uId = localStorage.getItem("uId") || -1;
		await this.handlerOpenDoorSh();
		this.listProductTag();
		this.currentChange();
	},
	methods: {
		handlerUploadImg(row) {
			this.productItem = row;
			this.isReUpload = false;
			this.showUploadImg = true;
		},
		handlerReUploadImg(row) {
			this.productItem = row;
			this.isReUpload = true;
			this.showUploadImg = true;
		},
		closeUploadImg() {
			this.showUploadImg = false;
		},
		refreshUploadImg() {
			this.showUploadImg = false;
			this.currentChange();
		},
		listProductTag() {
			this.$api
				.request(this.$url.ProductTag.list, this.$method.get)
				.then(res => {
					if (res.code === 0) {
						this.productTags = res.data;
					}
				});
		},
		cancel(dialog, status) {
			this.dialogProduct = dialog;
			if (status) {
				this.currentChange();
			}
		},
		closeLookImg() {
			this.showLookImg = false;
		},
		handlerLookImgs(row) {
			this.productItem = row;
			this.showLookImg = true;
		},
		normalizeOpenDoorSku(row) {
			const goodsId = row.goodsId || row.id || "";
			const skuInfo = row.goodsOpenDoorSkuDTO || {
				id: row.id || "",
				goodsId,
				gpSkuId: row.gpSkuId || "",
				skuId: row.skuId || "",
				skuResult: row.skuResult,
				comments: row.comments || "",
				rejectReasion: row.rejectReasion || "",
			};
			return {
				...row,
				goodsId,
				name: row.name || row.goodsName || "",
				url: row.url || row.goodsUrl || "",
				costPrice:
					row.costPrice !== undefined && row.costPrice !== null
						? row.costPrice
						: row.goodsPrice || "",
				goodsOpenDoorSkuDTO: skuInfo,
			};
		},
		handlerIsStatus(row, status) {
			const skuResult = row.goodsOpenDoorSkuDTO && row.goodsOpenDoorSkuDTO.skuResult;
			if (skuResult === null || skuResult === undefined) return status === null;
			if (skuResult === status) return true;
			return false;
		},
		handlerRejectReason(row) {
			if (!row.goodsOpenDoorSkuDTO) return "";
			return row.goodsOpenDoorSkuDTO.rejectReasion || "";
		},
		handlerROpenDoorStatus(row) {
			const skuResult = row.goodsOpenDoorSkuDTO && row.goodsOpenDoorSkuDTO.skuResult;
			if (skuResult === null || skuResult === undefined) return "";
			// Audit status: 0=Pending 1=Auditing 2=Approved 3=Rejected
			const statusMap = {
				0: "Pending",
				1: "Auditing",
				2: "Approved",
				3: "Rejected",
			};
			return statusMap[skuResult] || String(skuResult);
		},
		handlerRType(type) {
			if (!type) return "";

			return this.specifyTypeList.find(item => String(item.dictValue) === String(type))
				.dictLabel;
		},
		//开门柜规格类型
		async handlerOpenDoorSh() {
			try {
				const res = await this.$api.dict("gp_opendoor_skuresult");
				if (res.code === 0) {
					this.openDoorResList = res.data;
				}
			} catch (error) {
				return error;
			}
		},
		// //规格类型
		// async handlerGetSpecTType() {
		// 	try {
		// 		const res = await this.$api.dict("product_specify");
		// 		if (res.code === 0) {
		// 			this.specifyTypeList = res.data;
		// 		} else {
		// 		}
		// 	} catch (error) {
		// 	}
		// },
		currentChange(pageIndex) {
			this.loading = true;
			this.page.pageIndex = pageIndex ? pageIndex : 1;
			let obj = this.$cloud.objMerge(
				{
					name: this.search.name || "",
				},
				this.page
			);
			this.$api
				.request(this.$url.ProductLibrary.page, this.$method.get, obj)
				.then(res => {
					if (res.code === 0) {
						const records = Array.isArray(res.data.records) ? res.data.records : [];
						this.tableList = records.map(this.normalizeOpenDoorSku);
						this.page.totalSize = parseInt(res.data.total);
					}
					this.loading = false;
				})
				.catch(() => {
					this.loading = false;
				});
		},

		// 搜索
		onSubmit() {
			this.currentChange();
		},
		// 重置搜索
		resetSearch() {
			this.searchTime = null;
			Object.keys(this.search).forEach(key => {
				this.search[key] = null;
			});
			this.currentChange();
		},
		// 添加/编辑
		handlerInsert() {
			// 初始化insert数据
			this.fromMaterial = "1";
			this.product = createEmptyProduct();
			this.dialogProduct = true;
		},
		handleClose() {
			this.dialogVisible = false;
		},
		delProductType(row) {
			this.$confirm(this.$t("product.delete"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.ProductLibrary.delete, this.$method.delete, {
						id: row.id,
					})
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch(err => {
						this.$message.error(err.msg);
					});
			});
		},
		getProductType(row) {
			this.$confirm(this.$t("product.materialObtain"), this.$t("common.warning"), {
				confirmButtonText: this.$t("common.definite"),
				cancelButtonText: this.$t("common.cancel"),
				type: "warning",
			}).then(() => {
				this.$api
					.request(this.$url.ProductLibrary.obtain, this.$method.post, {
						id: row.id,
					})
					.then(res => {
						if (res.code === 0) {
							this.$notify({
								title: this.$t("common.tip"),
								message: res.msg,
								type: "success",
							});
							this.currentChange();
						} else {
							this.$message.error(res.msg);
						}
					})
					.catch(err => {
						this.$message.error(err.msg);
					});
			});
		},
		handlerLookItem(row) {
			this.srcList = [row.url];
		},
	},
};
</script>

<style scoped>
.el-dialog__header {
	padding: 20px;
}
.el-dialog__body {
	padding: 0 20px;
	height: auto !important;
}
.el-dialog__footer {
	padding: 20px;
}
</style>
